import type { LiveStudentSeat } from '../components/liveLesson/SeatingLiveCanvas';

export function getSeatIndexRowCol(index: number, columns: number) {
  return {
    row: Math.floor(index / columns),
    col: index % columns
  };
}

export function collectStudentIdsInRectangle(
  slots: Array<LiveStudentSeat | null>,
  columns: number,
  anchorIndex: number,
  targetIndex: number
): string[] {
  const anchor = getSeatIndexRowCol(anchorIndex, columns);
  const target = getSeatIndexRowCol(targetIndex, columns);
  const minRow = Math.min(anchor.row, target.row);
  const maxRow = Math.max(anchor.row, target.row);
  const minCol = Math.min(anchor.col, target.col);
  const maxCol = Math.max(anchor.col, target.col);
  const ids: string[] = [];

  for (let row = minRow; row <= maxRow; row += 1) {
    for (let col = minCol; col <= maxCol; col += 1) {
      const student = slots[row * columns + col];
      if (student) ids.push(student.id);
    }
  }

  return ids;
}

export function applySeatSelectionClick(options: {
  slots: Array<LiveStudentSeat | null>;
  columns: number;
  index: number;
  studentId: string;
  shiftKey: boolean;
  toggleKey: boolean;
  currentSelection: Set<string>;
  anchorIndex: number | null;
}): { nextSelection: Set<string>; anchorIndex: number | null } {
  const { slots, columns, index, studentId, shiftKey, toggleKey, currentSelection, anchorIndex } = options;

  if (shiftKey) {
    const resolvedAnchor = anchorIndex ?? index;
    const rectangleIds = collectStudentIdsInRectangle(slots, columns, resolvedAnchor, index);
    const nextSelection = new Set(currentSelection);
    rectangleIds.forEach((id) => nextSelection.add(id));
    return { nextSelection, anchorIndex: resolvedAnchor };
  }

  if (toggleKey) {
    const nextSelection = new Set(currentSelection);
    if (nextSelection.has(studentId)) {
      nextSelection.delete(studentId);
    } else {
      nextSelection.add(studentId);
    }
    return { nextSelection, anchorIndex: index };
  }

  return { nextSelection: currentSelection, anchorIndex };
}
